module.exports = __webpack_public_path__ + "static/img/logout.a2e84afb.svg";